import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import CheckIcon from '@atlaskit/icon/core/check-mark';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const premiumEditionColumnStyles = cssMap({
	root: {
		width: '91px',
		height: '312px',
		backgroundColor: token('color.background.input'),
		paddingTop: token('space.100'),
	},
	textRow: {
		height: '24px',
	},
	unlimitedText: {
		color: token('color.text.subtlest'),
		font: token('font.body.small'),
	},
});

/**
 * This depicts the checklist of features available in the Premium edition.
 */
export const PremiumEditionColumn = ({
	premiumPrice,
}: {
	premiumPrice: number;
}): React.JSX.Element => {
	const formattedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(premiumPrice);

	return (
		<Flex
			xcss={premiumEditionColumnStyles.root}
			direction="column"
			alignItems="center"
			gap="space.100"
		>
			<Flex direction="column" alignItems="center">
				<Text weight="semibold" color="color.text.subtlest">
					<FormattedMessage {...messages.premiumEdition} />
				</Text>
				<Text weight="semibold" color="color.text.subtlest">
					{formattedPrice}
				</Text>
			</Flex>
			<Flex direction="column" gap="space.200" alignItems="center">
				{/* Why not put this in a loop? Tried it. Didn't like it. */}
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.gray')} />
				<Flex xcss={premiumEditionColumnStyles.textRow} justifyContent="center" alignItems="center">
					<Box xcss={premiumEditionColumnStyles.unlimitedText}>
						<FormattedMessage {...messages.whiteboardsUnlimited} />
					</Box>
				</Flex>
			</Flex>
		</Flex>
	);
};
